import { render, staticRenderFns } from "./ChatMenu.vue?vue&type=template&id=f65ff9ba&"
import script from "./ChatMenu.vue?vue&type=script&lang=ts&"
export * from "./ChatMenu.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports